const configs_model = {
    "rewards_seconds": '',
    "rewards_question": '',
    "rewards_rescue": '',
    "member_invited": '',
    "member_invite_limit": '',
    "new_member": '',
};

export default configs_model;